import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { useApp } from "@/store";

const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT;
const ADSENSE_SLOT = process.env.REACT_APP_ADSENSE_SLOT;

export default function AdBanner({ country }) {
  const { user } = useApp();
  const [ad, setAd] = useState(null);
  const adRef = useRef(false);
  const loc = country || user?.country || "ALL";

  useEffect(() => {
    api.get("/ads", { params: { country: loc } }).then(({ data }) => setAd(data)).catch(() => setAd(null));
  }, [loc]);

  useEffect(() => {
    if (ADSENSE_CLIENT && !ad && !adRef.current) {
      adRef.current = true;
      try {
        if (!document.querySelector("script[data-adsense]")) {
          const s = document.createElement("script");
          s.async = true;
          s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
          s.crossOrigin = "anonymous";
          s.setAttribute("data-adsense", "1");
          document.head.appendChild(s);
        }
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch { /* ignore */ }
    }
  }, [ad]);

  // Internal ad (admin-managed) takes priority
  if (ad && ad.image_url) {
    return (
      <a href={ad.link_url || "#"} target="_blank" rel="noreferrer sponsored" data-testid="ad-internal"
        onClick={() => { api.post(`/ads/${ad.ad_id}/click?country=${encodeURIComponent(loc)}`).catch(() => {}); }}
        className="relative block overflow-hidden rounded-2xl border border-gray-200">
        <img src={ad.image_url} alt={ad.title} className="h-full w-full object-cover" />
        <span className="absolute right-2 top-2 rounded bg-black/50 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-widest text-white">Ad</span>
      </a>
    );
  }
  // Google AdSense fallback (only if configured)
  if (ADSENSE_CLIENT && ADSENSE_SLOT) {
    return (
      <div data-testid="ad-adsense" className="overflow-hidden rounded-2xl border border-gray-200">
        <ins className="adsbygoogle" style={{ display: "block" }} data-ad-client={ADSENSE_CLIENT} data-ad-slot={ADSENSE_SLOT} data-ad-format="auto" data-full-width-responsive="true" />
      </div>
    );
  }
  return null;
}
